/** Gemeinsame Produktmeldungen für Office- und lokale Dokument-Schreibaktionen. */
const messages: Record<string, string> = {
  spe_workspace_local_mutation_blocked:
    "Dokument wird gemeinsam bearbeitet; Bearbeitung zunächst abschließen.",
  // Seit dem 29.10.2026 sperrt keine Kostengrenze mehr; der Code bleibt nur für
  // eine freigegebene Reservierung oder eine Datei über 100 MB übrig.
  spe_budget_exceeded:
    "Die Arbeitskopie hat keine gültige Kostenreservierung mehr oder ist größer als 100 MB. Bitte das Dokument erneut öffnen.",
  spe_storage_usage_unknown_or_stale:
    "Der Speicherverbrauch muss zunächst geprüft werden. Bitte später erneut versuchen.",
  spe_confirmation_version_changed:
    "Der Dokumentstand hat sich geändert. Bitte den neuen Stand prüfen und erneut bewusst bestätigen.",
  spe_participant_confirmations_required:
    "Für den Abschluss fehlen noch Sicherungsbestätigungen der Bearbeiter.",
  spe_close_not_requested:
    "Bitte zunächst den gemeinsamen Abschluss anfordern.",
  spe_not_a_participant:
    "Nur bisherige Bearbeiter können ihren gespeicherten Stand bestätigen.",
  spe_legal_hold:
    "Die Arbeitskopie muss aufgrund einer Aufbewahrungssperre erhalten bleiben.",
  spe_remote_unstable:
    "Office meldet noch Änderungen. Die Arbeitskopie bleibt erhalten; bitte später erneut versuchen.",
  spe_write_lock_unverified:
    "Der Abschluss ist noch nicht sicher möglich. Bitte alle Office-Fenster schließen; die Arbeitskopie bleibt erhalten.",
  spe_source_unverified_or_too_large:
    "Diese Datei lässt sich nicht in Office bearbeiten: Sie ist größer als 100 MB oder im Speicher nicht lesbar.",
  spe_source_too_large:
    "Diese Datei ist für die Office-Bearbeitung zu groß (mehr als 100 MB).",
  spe_provisioning_pending:
    "Die Arbeitskopie wird noch vorbereitet. Bitte später dieselbe Datei erneut öffnen.",
  spe_sync_in_progress:
    "Die gemeinsame Bearbeitung wird gerade gesichert. Bitte später erneut versuchen.",
  spe_workspace_closing_or_failed:
    "Der gemeinsame Abschluss läuft oder benötigt eine Prüfung. Bitte den Sicherungsstatus prüfen; die Arbeitskopie bleibt erhalten.",
  spe_item_pending:
    "Die Arbeitskopie wird noch vorbereitet. Bitte später dieselbe Datei erneut öffnen.",
  spe_access_revoked:
    "Ihre Bearbeitungsberechtigung hat sich geändert. Die Arbeitskopie bleibt erhalten; bitte die Administration informieren.",
  spe_revoke_failed:
    "Die Freigaben konnten noch nicht sicher beendet werden. Die Arbeitskopie bleibt erhalten.",
  spe_versions_incomplete:
    "Noch nicht alle Fassungen sind in KMVS gesichert. Die Arbeitskopie bleibt erhalten.",
  spe_final_readback_failed:
    "Der gesicherte Endstand konnte noch nicht geprüft werden. Die Arbeitskopie bleibt erhalten.",
  spe_onlyoffice_transition_unverified:
    "Neue Office-Bearbeitungen warten auf die Betriebsfreigabe. Bitte die Administration informieren.",
  spe_workspace_busy:
    "Die Bearbeitung wird gerade vorbereitet oder gesichert. Bitte später erneut versuchen.",
  spe_provider_disabled:
    "Neue Office-Bearbeitungen sind derzeit nicht verfügbar.",
  spe_document_write_denied:
    "Für dieses Dokument fehlt das Schreibrecht.",
  spe_matrix_write_denied:
    "Für dieses Dokument fehlt das Schreibrecht.",
  spe_parent_missing:
    "Der Vorgang zu diesem Dokument ist nicht mehr erreichbar. Das Dokument lässt sich deshalb nicht in Office bearbeiten.",
  spe_document_kind_unsupported:
    "Diese Art von Dokument (E-Mail-Archiv, Notizbild, Termin-Dokument) lässt sich nicht in Office bearbeiten.",
  spe_format_unsupported:
    "Dieses Dateiformat lässt sich nicht in Office bearbeiten. Die Datei kann heruntergeladen werden.",
  spe_ooxml_invalid:
    "Diese Datei lässt sich nicht in Office bearbeiten (Kennwortschutz oder beschädigt). Die Datei kann heruntergeladen werden.",
  spe_makros_unsupported:
    "Diese Datei enthält Makros und lässt sich deshalb nicht in Office bearbeiten. Die Datei kann heruntergeladen werden.",
  spe_onlyoffice_session_open:
    "Zu diesem Dokument ist noch eine frühere Bearbeitung offen. Bitte die Administration informieren.",
  spe_source_changed_or_deleted:
    "Das Dokument wurde inzwischen geändert oder gelöscht. Bitte die Liste neu laden und erneut öffnen.",
  spe_source_hash_mismatch:
    "Die gespeicherte Datei passt nicht zu ihrem Prüfwert. Bitte die Administration informieren.",
  spe_identity_changed:
    "Das Microsoft-Konto passt nicht mehr zur laufenden Bearbeitung. Bitte die Administration informieren.",
  spe_identity_unavailable:
    "Die Microsoft-Anmeldung lässt sich gerade nicht prüfen. Bitte gleich noch einmal versuchen.",
  spe_workspace_not_found:
    "Zu diesem Dokument gibt es keine Office-Arbeitskopie.",
  spe_create_outcome_unresolved:
    "Die Arbeitskopie konnte bei Microsoft nicht angelegt werden. Bitte das Dokument erneut öffnen.",
  spe_provision_failed:
    "Die Arbeitskopie konnte bei Microsoft nicht angelegt werden. Bitte das Dokument erneut öffnen.",
  spe_tenant_unmapped:
    "Die Office-Bearbeitung ist nicht eingerichtet. Bitte die Administration informieren.",
  spe_prerequisites_unsatisfied:
    "Die Office-Bearbeitung ist nicht eingerichtet. Bitte die Administration informieren.",
  spe_config_invalid:
    "Die Office-Bearbeitung ist nicht eingerichtet. Bitte die Administration informieren.",
  spe_engine_implementation_pending:
    "Die Office-Bearbeitung ist nicht eingerichtet. Bitte die Administration informieren.",
  spe_final_local_hash_mismatch:
    "Der letzte Stand aus Office ist noch nicht in KMVS angekommen. Die Arbeitskopie bleibt erhalten.",
  spe_remote_missing_without_proof:
    "Die Arbeitskopie ist bei Microsoft nicht mehr auffindbar, der Abschluss ist aber nicht nachgewiesen. Bitte die Administration informieren.",
  spe_remote_absence_unconfirmed:
    "Microsoft hat das Löschen der Arbeitskopie noch nicht bestätigt. Der Abschluss wird erneut versucht.",
  spe_close_proof_incomplete:
    "Für den Abschluss fehlen noch Nachweise. Die Arbeitskopie bleibt erhalten.",
  spe_sync_lease_lost:
    "Die Aktion wurde von einem anderen Vorgang überholt. Bitte erneut versuchen.",
  spe_lease_lost:
    "Die Aktion wurde von einem anderen Vorgang überholt. Bitte erneut versuchen.",
  spe_readback_too_large:
    "Eine gesicherte Fassung ist größer als erlaubt und konnte nicht geprüft werden. Die Arbeitskopie bleibt erhalten.",
  spe_current_metadata_missing:
    "Microsoft hat zum aktuellen Stand keine Angaben geliefert. Die Sicherung wird erneut versucht.",
  spe_remote_version_changed:
    "Der Stand in Office hat sich während der Sicherung geändert. Die Sicherung wird erneut versucht.",
};
/** Nest-Standardtexte sagen dem Nutzer nichts; dann lieber der eigene Ersatztext. */
const generic = new Set([
  "internal server error",
  "forbidden",
  "forbidden resource",
  "conflict",
  "bad request",
  "not found",
  "unauthorized",
]);
export class DocumentWriteError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code: string | null = null,
    readonly requiresMicrosoftLogin = false,
  ) {
    super(message);
    this.name = "DocumentWriteError";
  }
}
export function documentWriteMessage(
  code: string | null,
  fallback = "Die Aktion ist fehlgeschlagen. Die Arbeitskopie bleibt erhalten.",
): string {
  return code && messages[code] ? messages[code] : fallback;
}
export async function documentWriteError(
  response: Response,
  fallback: string,
): Promise<DocumentWriteError> {
  const data = await response.json().catch(() => null);
  const raw =
    typeof data?.message === "string"
      ? data.message
      : typeof data?.code === "string"
        ? data.code
        : null;
  const login =
    response.status === 403 &&
    raw === "Microsoft-Konto bitte erneut anmelden oder verknüpfen.";
  const spe = !!raw && raw.startsWith("spe_");
  // Lesbare Servermeldungen („Das PDF konnte nicht gedreht werden.“) gehören
  // zum Nutzer; Codes und Nest-Standardtexte nicht.
  const readable =
    !!raw && !spe && !generic.has(raw.trim().toLowerCase()) ? raw : null;
  return new DocumentWriteError(
    login
      ? "Bitte Ihr Microsoft-Geschäftskonto erneut anmelden oder verknüpfen."
      : documentWriteMessage(
          raw,
          readable ??
            (spe && response.status !== 403
              ? "Office konnte die Aktion nicht ausführen. Die Arbeitskopie bleibt erhalten."
              : fallback),
        ),
    response.status,
    raw,
    login,
  );
}
